// extracted by mini-css-extract-plugin
export default {"AddressItem_link":"srFvv","AddressItem_mainLabel":"Qh228","AddressItem_secondaryLabel":"WBFZf"};